export const AcceptedOutsideOptions = {
  follow_up: 'follow_up',
  recap_wrt: 'recap_wrt',
  recap_vrt: 'recap_vrt',
  verbal_recap_wrt: 'verbal_recap_wrt',
  verbal_recap_vrt: 'verbal_recap_vrt'
};



// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/Defaults.js